import "regenerator-runtime/runtime.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useUser } from 'components';
import { showApiError, convertToAdditionalCurrency } from 'utils';
import { getAllPartners, getPartnerFundsBalance } from 'services';
import { cardsContainer, card, cardHeader, cardBody, dataField, fieldLabel, amountValue, secondaryAmount, emptyState } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerFundsSummary = function PartnerFundsSummary() {
  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      partnerBalances = _useState2[0],
      setPartnerBalances = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  useEffect(function () {
    fetchPartnersWithBalances();
  }, []);

  var fetchPartnersWithBalances = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var partners, _yield$getAllPartners, _yield$getAllPartners2, res, err, balances;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              partners = [];

              if (!(userInfo !== null && userInfo !== void 0 && userInfo.partners && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.partners.length) > 0)) {
                _context2.next = 6;
                break;
              }

              partners = userInfo.partners;
              _context2.next = 17;
              break;

            case 6:
              _context2.next = 8;
              return getAllPartners();

            case 8:
              _yield$getAllPartners = _context2.sent;
              _yield$getAllPartners2 = _slicedToArray(_yield$getAllPartners, 2);
              res = _yield$getAllPartners2[0];
              err = _yield$getAllPartners2[1];

              if (!err) {
                _context2.next = 16;
                break;
              }

              showApiError(err);
              setLoading(false);
              return _context2.abrupt("return");

            case 16:
              partners = res;

            case 17:
              _context2.next = 19;
              return partners.reduce( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accPromise, partner) {
                  var acc, _yield$getPartnerFund, _yield$getPartnerFund2, res, err;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return accPromise;

                        case 2:
                          acc = _context.sent;
                          _context.next = 5;
                          return getPartnerFundsBalance({
                            partner_id: partner.id
                          });

                        case 5:
                          _yield$getPartnerFund = _context.sent;
                          _yield$getPartnerFund2 = _slicedToArray(_yield$getPartnerFund, 2);
                          res = _yield$getPartnerFund2[0];
                          err = _yield$getPartnerFund2[1];
                          return _context.abrupt("return", [].concat(_toConsumableArray(acc), [{
                            id: partner.id,
                            name: partner.name,
                            balance: err ? null : res
                          }]));

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x, _x2) {
                  return _ref2.apply(this, arguments);
                };
              }(), Promise.resolve([]));

            case 19:
              balances = _context2.sent;
              setPartnerBalances(balances);
              setLoading(false);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchPartnersWithBalances() {
      return _ref.apply(this, arguments);
    };
  }();

  if (loading) return null;
  if (partnerBalances.length === 0) return ___EmotionJSX("div", {
    css: emptyState
  }, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0438!");
  return ___EmotionJSX("div", {
    css: cardsContainer
  }, partnerBalances.map(function (partner) {
    var _partner$balance$comm, _partner$balance, _partner$balance2, _partner$balance3, _partner$balance4, _partner$balance$avai, _partner$balance5, _partner$balance6, _partner$balance7, _partner$balance8, _partner$balance$prof, _partner$balance9, _partner$balance10, _partner$balance11, _partner$balance12;

    return ___EmotionJSX("div", {
      css: card,
      key: partner.id
    }, ___EmotionJSX("div", {
      css: cardHeader
    }, ___EmotionJSX("span", {
      className: "card-name"
    }, partner.name)), ___EmotionJSX("div", {
      css: cardBody
    }, ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438 \u043D\u0435\u043E\u0442\u0447\u0435\u0442\u0435\u043D\u0438 \u0442\u0430\u043A\u0441\u0438 \u0414\u041F"), ___EmotionJSX("span", {
      css: amountValue
    }, (_partner$balance$comm = (_partner$balance = partner.balance) === null || _partner$balance === void 0 ? void 0 : _partner$balance.commission_report_balance) !== null && _partner$balance$comm !== void 0 ? _partner$balance$comm : 0, ___EmotionJSX("span", {
      className: "currency"
    }, (_partner$balance2 = partner.balance) === null || _partner$balance2 === void 0 ? void 0 : _partner$balance2.currency)), ___EmotionJSX("span", {
      css: secondaryAmount
    }, convertToAdditionalCurrency({
      value: (_partner$balance3 = partner.balance) === null || _partner$balance3 === void 0 ? void 0 : _partner$balance3.commission_report_balance,
      fromCurrency: (_partner$balance4 = partner.balance) === null || _partner$balance4 === void 0 ? void 0 : _partner$balance4.currency
    }))), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u0421\u044A\u0431\u0440\u0430\u043D\u0438 \u043D\u0435\u043E\u0442\u0447\u0435\u0442\u0435\u043D\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0438\u044F \u043F\u043E \u0433\u043B\u0430\u0432\u043D\u0438\u0446\u0438 \u0438 \u043B\u0438\u0445\u0432\u0438"), ___EmotionJSX("span", {
      css: amountValue
    }, (_partner$balance$avai = (_partner$balance5 = partner.balance) === null || _partner$balance5 === void 0 ? void 0 : _partner$balance5.available_balance) !== null && _partner$balance$avai !== void 0 ? _partner$balance$avai : 0, ___EmotionJSX("span", {
      className: "currency"
    }, (_partner$balance6 = partner.balance) === null || _partner$balance6 === void 0 ? void 0 : _partner$balance6.currency)), ___EmotionJSX("span", {
      css: secondaryAmount
    }, convertToAdditionalCurrency({
      value: (_partner$balance7 = partner.balance) === null || _partner$balance7 === void 0 ? void 0 : _partner$balance7.available_balance,
      fromCurrency: (_partner$balance8 = partner.balance) === null || _partner$balance8 === void 0 ? void 0 : _partner$balance8.currency
    }))), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041F\u0435\u0447\u0430\u043B\u0431\u0430 \u0414\u041F \u0441\u043B\u0435\u0434 \u043E\u0442\u0447\u0435\u0442"), ___EmotionJSX("span", {
      css: amountValue
    }, (_partner$balance$prof = (_partner$balance9 = partner.balance) === null || _partner$balance9 === void 0 ? void 0 : _partner$balance9.profit_balance) !== null && _partner$balance$prof !== void 0 ? _partner$balance$prof : 0, ___EmotionJSX("span", {
      className: "currency"
    }, (_partner$balance10 = partner.balance) === null || _partner$balance10 === void 0 ? void 0 : _partner$balance10.currency)), ___EmotionJSX("span", {
      css: secondaryAmount
    }, convertToAdditionalCurrency({
      value: (_partner$balance11 = partner.balance) === null || _partner$balance11 === void 0 ? void 0 : _partner$balance11.profit_balance,
      fromCurrency: (_partner$balance12 = partner.balance) === null || _partner$balance12 === void 0 ? void 0 : _partner$balance12.currency
    })))));
  }));
};

export default PartnerFundsSummary;